
import { Component, Vue, Prop } from 'vue-property-decorator'
import { StationClient } from '@/api'
import _ from 'lodash'
import BaseEditor from '@/views/BaseEditor'
import FileUpload from 'vue-upload-component'
import request from '@/utils/request'

@Component({
  name: 'StationEditor',
  components: {
    FileUpload
  }
})
export default class extends BaseEditor {
  @Prop({ default: false })
  private self !: boolean

  public constructor() {
    super()
    this.client = new StationClient()
    this.data = { name: null, phone: null, address: null, latitude: null, longitude: null, cover: null, cngHandlingFeeRatio: null, cngWepayDiscount: null, lngHandlingFeeRatio: null, lngWepayDiscount: null }
    this.rules = {
      name: [{ required: true, message: '名称为必填项', trigger: 'blur' }],
      username: [{ required: true, message: '用户名为必填项', trigger: 'blur' }],
      address: [{ required: true, message: '地址为必填项', trigger: 'blur' }],
      phone: [{ required: true, message: '电话为必填项', trigger: 'blur' }],
      latitude: [{ required: true, message: '坐标为必填项', trigger: 'blur' }],
      longitude: [{ required: true, message: '坐标为必填项', trigger: 'blur' }],
      cngHandlingFeeRatio: [{ required: true, message: 'CNG手续费比例为必填项', trigger: 'blur' }],
      cngWepayDiscount: [{ required: true, message: 'CNG微信支付优惠比例为必填项', trigger: 'blur' }],
      lngHandlingFeeRatio: [{ required: true, message: 'LNG手续费比例为必填项', trigger: 'blur' }],
      lngWepayDiscount: [{ required: true, message: 'LNG微信支付优惠比例为必填项', trigger: 'blur' }]
    }
  }

  public async reset() {
    this.data = { name: null, phone: null, address: null, latitude: null, longitude: null, cover: null, cngHandlingFeeRatio: null, cngWepayDiscount: null, lngHandlingFeeRatio: null, lngWepayDiscount: null }
  }

  protected generateData(): any {
    let data = {
      'name': this.data.name,
      'phone': this.data.phone,
      'address': this.data.address,
      'latitude': Number(this.data.latitude),
      'longitude': Number(this.data.longitude),
      'cngHandlingFeeRatio': Number(this.data.cngHandlingFeeRatio),
      'cngWepayDiscount': Number(this.data.cngWepayDiscount),
      'lngHandlingFeeRatio': Number(this.data.lngHandlingFeeRatio),
      'lngWepayDiscount': Number(this.data.lngWepayDiscount)
    }
    if (!_.isNil(this.data.cover)) {
      data = _.merge(data, { 'cover': this.data.cover })
    }
    return data
  }

  protected inputFilter(newFile: File, oldFile: File, prevent: Function) {
    if (newFile && !oldFile) {
      // Before adding a file
      // 添加文件前
      // Filter system files or hide files
      // 过滤系统文件 和隐藏文件
      if (/(\/|^)(Thumbs\.db|desktop\.ini|\..+)$/.test(newFile.name)) {
        return prevent()
      }
      // Filter php html js file
      // 过滤 php html js 文件
      if (/\.(php5?|html?|jsx?)$/i.test(newFile.name)) {
        return prevent()
      }
    }
  }

  protected inputFile(newFile: any, oldFile: any) {
    var reader = new FileReader()
    const self = this
    reader.addEventListener(
      'load',
      function() {
        self.data.cover = reader.result
      },
      false
    )

    if (newFile) {
      reader.readAsDataURL(newFile.file)
    }
  }

  protected async uploadFile(data: any):Promise<String> {
    const formData = new FormData()
    formData.append('file', data.file)
    const url = await request({
      url: '/minio/tianshan/random',
      method: 'post',
      data: formData
    })
    return url.toString()
  }

  protected async beforeSave(): Promise<Boolean> {
    const upload = this.$refs['upload'] as any
    if (upload.files.length === 1) {
      this.listLoading = true
      this.data.cover = await this.uploadFile(upload.files[0])
      this.listLoading = false
      upload.clear()
    }
    return true
  }

  public async saveData():Promise<Boolean> {
    const self = this
    const form = self.$refs['dataForm'] as any
    return new Promise<Boolean>((resolve, reject) => {
      form.validate(async(valid: any) => {
        if (valid) {
          if (await this.beforeSave()) {
            if (Number(this.id) !== -1) {
              self.listLoading = true
              await self.client.update(
                self.id,
                self.generateData()
              )
              self.listLoading = false
              resolve(true)
            } else {
              const stationClient = self.client as StationClient
              await stationClient.createWithUser(self.generateData(), this.data.username)
              resolve(true)
            }
            self.$notify({
              title: '成功',
              message: '更新成功',
              type: 'success',
              duration: 2000
            })
          }
        } else {
          resolve(false)
        }
      })
    })
  }
}
